module.exports = __webpack_public_path__ + "img/xpx_xparty.fce199f.png";